// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import Wf_iconSvg from "./assets/wf_icon.svg";
import Button_logoutSvg from "./assets/button_logout.svg";
import Icon_nav_levelSvg from "./assets/icon_nav_level.svg";
import Icon_nav_journeySvg from "./assets/icon_nav_journey.svg";
import Icon_nav_librarySvg from "./assets/icon_nav_library.svg";
import Student_overviewSvg from "./assets/student_overview.svg";
import Icon_nav_word_listSvg from "./assets/icon_nav_word_list.svg";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import Button_logout_hoverSvg from "./assets/button_logout_hover.svg";
import Icon_nav_collectionSvg from "./assets/icon_nav_collection.svg";
import Student_proficiencySvg from "./assets/student_proficiency.svg";
import Button_logout_activeSvg from "./assets/button_logout_active.svg";
import Icon_nav_intrepizineSvg from "./assets/icon_nav_intrepizine.svg";
import * as CssUtils$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/CssUtils.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as FontAwesomeIcon$LiteracyplanetClientSxEntry from "../FontAwesomeIcon.res.mjs";
import * as StoryverseComponents$LiteracyplanetClientSxEntry from "./StoryverseComponents.res.mjs";
import * as StoryverseLevelPanel$LiteracyplanetClientSxEntry from "./StoryverseLevelPanel.res.mjs";
import * as StoryversePanelContext$LiteracyplanetClientSxEntry from "../StoryversePanelContext.res.mjs";
import * as StoryverseNavigationQuery$LiteracyplanetClientSxEntry from "../StoryverseNavigationQuery.res.mjs";

var reportsIcon = Student_overviewSvg;

var css = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(reportsIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className = Curry._1(Css.merge, {
      hd: css,
      tl: {
        hd: "ReportsNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$ReportsNav(props) {
  return React.createElement("div", {
              className: className
            });
}

var ReportsNav = {
  css: css,
  className: className,
  make: StoryverseHeader$ReportsNav
};

var journeyNavIcon = Icon_nav_journeySvg;

var css$1 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(journeyNavIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$1 = Curry._1(Css.merge, {
      hd: css$1,
      tl: {
        hd: "JourneyNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$JourneyNav(props) {
  return React.createElement("div", {
              className: className$1
            });
}

var JourneyNav = {
  css: css$1,
  className: className$1,
  make: StoryverseHeader$JourneyNav
};

var libraryNavIcon = Icon_nav_librarySvg;

var css$2 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(libraryNavIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$2 = Curry._1(Css.merge, {
      hd: css$2,
      tl: {
        hd: "LibraryNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$LibraryNav(props) {
  return React.createElement("div", {
              className: className$2
            });
}

var LibraryNav = {
  css: css$2,
  className: className$2,
  make: StoryverseHeader$LibraryNav
};

var academyNavIcon = Student_proficiencySvg;

var css$3 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(academyNavIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(106.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$3 = Curry._1(Css.merge, {
      hd: css$3,
      tl: {
        hd: "AcademyNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$AcademyNav(props) {
  return React.createElement("div", {
              className: className$3
            });
}

var AcademyNav = {
  css: css$3,
  className: className$3,
  make: StoryverseHeader$AcademyNav
};

var wordFlyersNavIcon = Wf_iconSvg;

var css$4 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(wordFlyersNavIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(106.0)),
                tl: {
                  hd: Css.width(Css.pct(110.0)),
                  tl: {
                    hd: Css.marginLeft(Css.pct(-10.0)),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var className$4 = Curry._1(Css.merge, {
      hd: css$4,
      tl: {
        hd: "WordFlyersNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$WordFlyersNav(props) {
  return React.createElement("div", {
              className: className$4
            });
}

var WordFlyersNav = {
  css: css$4,
  className: className$4,
  make: StoryverseHeader$WordFlyersNav
};

var wordListNavIcon = Icon_nav_word_listSvg;

var css$5 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundImage(Css.url(wordListNavIcon)),
        tl: {
          hd: Css.backgroundSize("contain"),
          tl: {
            hd: Css.backgroundRepeat("noRepeat"),
            tl: {
              hd: Css.backgroundPosition(Css.center),
              tl: {
                hd: Css.height(Css.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$5 = Curry._1(Css.merge, {
      hd: css$5,
      tl: {
        hd: "WordListNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$WordListNav(props) {
  return React.createElement("div", {
              className: className$5
            });
}

var WordListNav = {
  css: css$5,
  className: className$5,
  make: StoryverseHeader$WordListNav
};

var levelNavIcon = Icon_nav_levelSvg;

var r = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.marginTop,
        10
      ],
      tl: /* [] */0
    });

var css$6 = Curry._1(Css.style, {
      hd: Css.backgroundImage(Css.url(levelNavIcon)),
      tl: {
        hd: Css.backgroundSize("contain"),
        tl: {
          hd: Css.backgroundRepeat("noRepeat"),
          tl: {
            hd: Css.backgroundPosition(Css.center),
            tl: {
              hd: Css.display(Css.grid),
              tl: {
                hd: Css.height(Css.pct(96.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$6 = Curry._1(Css.merge, {
      hd: css$6,
      tl: {
        hd: r,
        tl: {
          hd: "LevelNav",
          tl: /* [] */0
        }
      }
    });

function StoryverseHeader$LevelNav(props) {
  return React.createElement("div", {
              className: className$6
            });
}

var LevelNav = {
  r: r,
  css: css$6,
  className: className$6,
  make: StoryverseHeader$LevelNav
};

var collectionNavIcon = Icon_nav_collectionSvg;

var css$7 = Curry._1(Css.style, {
      hd: Css.backgroundImage(Css.url(collectionNavIcon)),
      tl: {
        hd: Css.backgroundSize("contain"),
        tl: {
          hd: Css.backgroundRepeat("noRepeat"),
          tl: {
            hd: Css.backgroundPosition(Css.center),
            tl: {
              hd: Css.display(Css.grid),
              tl: {
                hd: Css.height(Css.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$7 = Curry._1(Css.merge, {
      hd: css$7,
      tl: {
        hd: "CollectionNav",
        tl: /* [] */0
      }
    });

function StoryverseHeader$CollectionNav(props) {
  return React.createElement("div", {
              className: className$7
            });
}

var CollectionNav = {
  css: css$7,
  className: className$7,
  make: StoryverseHeader$CollectionNav
};

var intrepizineNavIcon = Icon_nav_intrepizineSvg;

var r$1 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.marginTop,
        10
      ],
      tl: /* [] */0
    });

var css$8 = Curry._1(Css.style, {
      hd: Css.backgroundImage(Css.url(intrepizineNavIcon)),
      tl: {
        hd: Css.backgroundSize("contain"),
        tl: {
          hd: Css.backgroundRepeat("noRepeat"),
          tl: {
            hd: Css.backgroundPosition(Css.center),
            tl: {
              hd: Css.display(Css.grid),
              tl: {
                hd: Css.height(Css.pct(87.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$8 = Curry._1(Css.merge, {
      hd: css$8,
      tl: {
        hd: r$1,
        tl: {
          hd: "IntrepizineNav",
          tl: /* [] */0
        }
      }
    });

function StoryverseHeader$IntrepizineNav(props) {
  return React.createElement("div", {
              className: className$8
            });
}

var IntrepizineNav = {
  r: r$1,
  css: css$8,
  className: className$8,
  make: StoryverseHeader$IntrepizineNav
};

var logoutNavIcon = Button_logoutSvg;

var logoutNavIconHover = Button_logout_hoverSvg;

var logoutNavIconActive = Button_logout_activeSvg;

var r$2 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        51
      ],
      tl: {
        hd: [
          Css.height,
          43
        ],
        tl: {
          hd: [
            Css.marginTop,
            19
          ],
          tl: {
            hd: [
              Css.marginLeft,
              8
            ],
            tl: /* [] */0
          }
        }
      }
    });

var css$9 = Curry._1(Css.style, {
      hd: Css.backgroundImage(Css.url(logoutNavIcon)),
      tl: {
        hd: Css.backgroundSize("contain"),
        tl: {
          hd: Css.backgroundRepeat("noRepeat"),
          tl: {
            hd: Css.backgroundPosition(Css.center),
            tl: {
              hd: Css.display(Css.grid),
              tl: {
                hd: Css.hover({
                      hd: Css.backgroundImage(Css.url(logoutNavIconHover)),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: Css.active({
                        hd: Css.backgroundImage(Css.url(logoutNavIconActive)),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: CssUtils$LiteracyplanetClientFlags.preloadImages({
                          hd: logoutNavIconActive,
                          tl: {
                            hd: logoutNavIconHover,
                            tl: /* [] */0
                          }
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var className$9 = Curry._1(Css.merge, {
      hd: css$9,
      tl: {
        hd: r$2,
        tl: {
          hd: "LogoutNav",
          tl: /* [] */0
        }
      }
    });

function StoryverseHeader$LogoutNav(props) {
  return React.createElement("div", {
              className: className$9
            }, props.children);
}

var LogoutNav = {
  r: r$2,
  css: css$9,
  className: className$9,
  make: StoryverseHeader$LogoutNav
};

var r$3 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        76
      ],
      tl: {
        hd: [
          Css.height,
          66
        ],
        tl: /* [] */0
      }
    });

var css$10 = Curry._1(Css.style, /* [] */0);

var className$10 = Curry._1(Css.merge, {
      hd: r$3,
      tl: {
        hd: css$10,
        tl: /* [] */0
      }
    });

var ResizeOnHoverStyle = {
  r: r$3,
  css: css$10,
  className: className$10
};

function StoryverseHeader$ResizeOnHover(props) {
  return React.createElement("div", {
              className: className$10
            }, props.children);
}

var ResizeOnHover = {
  make: StoryverseHeader$ResizeOnHover
};

var cssHover = Theme$LiteracyplanetClientFlags.dimensionsHover(className$10, 84, 72);

var css$11 = Curry._1(Css.style, {
      hd: Css.cursor(Css.pointer),
      tl: /* [] */0
    });

var className$11 = Curry._1(Css.merge, {
      hd: cssHover,
      tl: {
        hd: css$11,
        tl: {
          hd: "HeaderIcon",
          tl: /* [] */0
        }
      }
    });

function StoryverseHeader$HeaderIcon(props) {
  var __isExpanded = props.isExpanded;
  var __canBeExpanded = props.canBeExpanded;
  var screenReaderLabel = props.screenReaderLabel;
  var children = props.children;
  var onClick = props.onClick;
  var canBeExpanded = __canBeExpanded !== undefined ? __canBeExpanded : false;
  var isExpanded = __isExpanded !== undefined ? __isExpanded : false;
  if (canBeExpanded) {
    return React.createElement("button", {
                "aria-label": screenReaderLabel,
                "aria-expanded": isExpanded,
                className: className$11,
                title: screenReaderLabel,
                onClick: onClick
              }, children);
  } else {
    return React.createElement("button", {
                "aria-label": screenReaderLabel,
                className: className$11,
                title: screenReaderLabel,
                onClick: onClick
              }, children);
  }
}

var HeaderIcon = {
  cssHover: cssHover,
  css: css$11,
  className: className$11,
  make: StoryverseHeader$HeaderIcon
};

function StoryverseHeader$InitialsIcon(props) {
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.top,
          12
        ],
        tl: {
          hd: [
            Css.left,
            -100
          ],
          tl: /* [] */0
        }
      });
  var css = Curry._1(Css.style, {
        hd: Css.position("absolute"),
        tl: /* [] */0
      });
  var className = Curry._1(Css.merge, {
        hd: css,
        tl: {
          hd: r,
          tl: {
            hd: "InitialsIcon",
            tl: /* [] */0
          }
        }
      });
  return React.createElement("div", {
              className: className
            }, props.children);
}

var InitialsIcon = {
  make: StoryverseHeader$InitialsIcon
};

function StoryverseHeader$TeacherModeWidget(props) {
  var screenReaderLabel = props.screenReaderLabel;
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.height,
          20
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.borderBottomRightRadius,
            6
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.padding,
              10
            ],
            tl: {
              hd: [
                Css.gridGap,
                6
              ],
              tl: {
                hd: [
                  Theme$LiteracyplanetClientFlags.borderRightWidth,
                  2
                ],
                tl: {
                  hd: [
                    Theme$LiteracyplanetClientFlags.borderBottomWidth,
                    2
                  ],
                  tl: {
                    hd: [
                      Theme$LiteracyplanetClientFlags.fontSize,
                      12
                    ],
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      });
  var css = Curry._1(Css.style, {
        hd: Css.textDecoration(Css.none),
        tl: {
          hd: Css.fontFamily({
                NAME: "custom",
                VAL: "museo-sans-rounded"
              }),
          tl: /* [] */0
        }
      });
  var responsive = Curry._1(Css.merge, {
        hd: css,
        tl: {
          hd: r,
          tl: {
            hd: "TeacherModeWidget",
            tl: /* [] */0
          }
        }
      });
  var iconSize = Curry._1(Css.merge, {
        hd: Theme$LiteracyplanetClientFlags.resize({
              hd: [
                Css.width,
                12
              ],
              tl: /* [] */0
            }),
        tl: /* [] */0
      });
  return React.createElement("button", {
              "aria-label": screenReaderLabel,
              className: TailwindMerge.twMerge("fixed left-0 top-0 z-10 my-auto flex flex-row items-center border-white bg-[#0dadf7] font-sx font-bold text-white shadow-md shadow-black/50 hover:cursor-pointer hover:bg-[#0979ac]", responsive),
              title: screenReaderLabel,
              onClick: props.onClick
            }, React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                  iconName: "left-to-bracket",
                  className: TailwindMerge.twMerge("text-white", iconSize),
                  ariaHidden: true
                }), React.createElement("div", {
                  "aria-hidden": true
                }, "Teacher Mode"));
}

var TeacherModeWidget = {
  make: StoryverseHeader$TeacherModeWidget
};

function StoryverseHeader(props) {
  var onClickReports = props.onClickReports;
  var onClickCollections = props.onClickCollections;
  var onClickLibrary = props.onClickLibrary;
  var onClickMyWords = props.onClickMyWords;
  var onClickIntrepizine = props.onClickIntrepizine;
  var onClickWordFlyers = props.onClickWordFlyers;
  var onClickAcademy = props.onClickAcademy;
  var onClickMissions = props.onClickMissions;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var wordFlyersAvailable = Curry._1(hasFlag, "CanAccessWordFlyers") && Curry._1(hasFlag, "StudentHasWordFlyers");
  var match = Curry._1(StoryversePanelContext$LiteracyplanetClientSxEntry.Context.use, undefined);
  var onToggleLevelPanel = match.togglePanel;
  var onCloseLevelPanel = match.closePanel;
  var isLevelPanelOpen = match.panelOpen;
  var navigation = StoryverseNavigationQuery$LiteracyplanetClientSxEntry.use(!isLevelPanelOpen);
  return React.createElement(React.Fragment, {}, props.showTeacherModeWidget ? React.createElement(StoryverseHeader$TeacherModeWidget, {
                    screenReaderLabel: "Return to Teacher Mode",
                    onClick: props.onClickTeacherMode
                  }) : null, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.HeaderSubPanel.make, {
                  children: null,
                  screenReaderLabel: "Navigation Toolbar"
                }, React.createElement(StoryverseHeader$InitialsIcon, {
                      children: props.settingsMenu
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.HeaderIconPanel.make, {
                      children: null
                    }, React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onToggleLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$LevelNav, {})
                              }),
                          screenReaderLabel: "Storyverse Menu",
                          canBeExpanded: true,
                          isExpanded: isLevelPanelOpen
                        }), React.createElement(StoryverseLevelPanel$LiteracyplanetClientSxEntry.make, {
                          userName: props.userName,
                          navigation: navigation,
                          onClickBog: props.onClickBog,
                          onClickCollections: onClickCollections,
                          lockArcade: props.lockArcade,
                          onClickArcade: props.onClickArcade,
                          lockShop: props.lockShop,
                          onClickShop: props.onClickShop,
                          isLevelPanelOpen: isLevelPanelOpen,
                          onCloseLevelPanel: onCloseLevelPanel
                        }), React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onClickMissions, undefined);
                              Curry._1(onCloseLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$JourneyNav, {})
                              }),
                          screenReaderLabel: "Journey"
                        }), Curry._1(hasFlag, {
                          NAME: "Unleash",
                          VAL: "release_sxHasAcademy"
                        }) ? React.createElement(StoryverseHeader$HeaderIcon, {
                            onClick: (function (param) {
                                Curry._1(onClickAcademy, undefined);
                                Curry._1(onCloseLevelPanel, undefined);
                              }),
                            children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                  children: React.createElement(StoryverseHeader$AcademyNav, {})
                                }),
                            screenReaderLabel: "Academy"
                          }) : null, wordFlyersAvailable ? React.createElement(StoryverseHeader$HeaderIcon, {
                            onClick: (function (param) {
                                Curry._1(onClickWordFlyers, undefined);
                                Curry._1(onCloseLevelPanel, undefined);
                              }),
                            children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                  children: React.createElement(StoryverseHeader$WordFlyersNav, {})
                                }),
                            screenReaderLabel: "Word Flyers"
                          }) : null, props.showLibraryLink ? React.createElement(StoryverseHeader$HeaderIcon, {
                            onClick: (function (param) {
                                Curry._1(onClickLibrary, undefined);
                                Curry._1(onCloseLevelPanel, undefined);
                              }),
                            children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                  children: React.createElement(StoryverseHeader$LibraryNav, {})
                                }),
                            screenReaderLabel: "Library"
                          }) : null, React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onClickMyWords, undefined);
                              Curry._1(onCloseLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$WordListNav, {})
                              }),
                          screenReaderLabel: "My Words"
                        }), React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onClickCollections, undefined);
                              Curry._1(onCloseLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$CollectionNav, {})
                              }),
                          screenReaderLabel: "Collections"
                        }), React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onClickIntrepizine, undefined);
                              Curry._1(onCloseLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$IntrepizineNav, {})
                              }),
                          screenReaderLabel: "Intrepizine"
                        }), React.createElement(StoryverseHeader$HeaderIcon, {
                          onClick: (function (param) {
                              Curry._1(onClickReports, undefined);
                              Curry._1(onCloseLevelPanel, undefined);
                            }),
                          children: React.createElement(StoryverseHeader$ResizeOnHover, {
                                children: React.createElement(StoryverseHeader$ReportsNav, {})
                              }),
                          screenReaderLabel: "Reports"
                        })), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.CobraSFXBtnContainer.make, {})));
}

var ratio = Theme$LiteracyplanetClientFlags.resize;

var resizeGridCols = Theme$LiteracyplanetClientFlags.resizeGridCols;

var resizeGridRows = Theme$LiteracyplanetClientFlags.resizeGridRows;

var maximumWidth = Theme$LiteracyplanetClientFlags.maximumWidth;

var make = StoryverseHeader;

export {
  ratio ,
  resizeGridCols ,
  resizeGridRows ,
  maximumWidth ,
  reportsIcon ,
  ReportsNav ,
  journeyNavIcon ,
  JourneyNav ,
  libraryNavIcon ,
  LibraryNav ,
  academyNavIcon ,
  AcademyNav ,
  wordFlyersNavIcon ,
  WordFlyersNav ,
  wordListNavIcon ,
  WordListNav ,
  levelNavIcon ,
  LevelNav ,
  collectionNavIcon ,
  CollectionNav ,
  intrepizineNavIcon ,
  IntrepizineNav ,
  logoutNavIcon ,
  logoutNavIconHover ,
  logoutNavIconActive ,
  LogoutNav ,
  ResizeOnHoverStyle ,
  ResizeOnHover ,
  HeaderIcon ,
  InitialsIcon ,
  TeacherModeWidget ,
  make ,
}
/* reportsIcon Not a pure module */
